import { createContext, useContext, type ReactNode } from "react";
import { useWorkFiles, type WorkFilesData } from "../hooks/useWorkFiles";

const WorkFilesContext = createContext<WorkFilesData | undefined>(undefined);

interface WorkFilesProviderProps {
  children: ReactNode;
}

export const WorkFilesProvider = ({ children }: WorkFilesProviderProps) => {
  const data = useWorkFiles();

  return (
    <WorkFilesContext.Provider value={data}>
      {children}
    </WorkFilesContext.Provider>
  );
};

export const useWorkFilesContext = (): WorkFilesData => {
  const context = useContext(WorkFilesContext);
  if (context === undefined) {
    throw new Error("useWorkFilesContext must be used within a WorkFilesProvider");
  }
  return context;
};
